import Box from '@components/base/Box'
import { Button } from '@components/inputs/Button'
import { TextInput } from '@components/inputs/TextInput'
import { useEventEditor } from '@libs/CreateEvent/useEventEditor'
import React from 'react'
import { Form } from '@components/inputs/Form'
import { useMutation } from '@apollo/client'
import { ELEVATE_ACCOUNT } from '@graphql/users/elevateAccount'
import { useAuth } from '@libs/Auth/useAuth'

const SpaceCreationForm = () => {
  const { syncProfile } = useAuth()
  const { errors, setErrors } = useEventEditor()

  const [elevateAccount, { loading }] = useMutation(ELEVATE_ACCOUNT)

  const errorHandler =
    (id: string, alert: boolean = false) =>
    (message: string, testId: string) => {
      const payload = [...errors]

      const hasError = !!message || message !== ''
      const isCleared = payload.find((f) => f.eleId === testId) && !hasError

      if (isCleared) return setErrors(payload.filter((f) => f.eleId !== testId))

      const isDuplicate = !!payload.find((p) => p.eleId === testId)

      const newError = {
        step: id ?? 'unknown',
        message,
        eleId: testId,
        alert,
      }

      if (!isDuplicate && hasError) setErrors([...payload, newError])
    }

  return (
    <>
      <Box className="w-full">
        <Form
          error={errors?.[0]?.message}
          onSubmit={async (data) => {
            const { nameYourEventSpace } = data
            elevateAccount({
              variables: {
                orgName: nameYourEventSpace,
              },
              onCompleted: (res) => {
                if (res.elevateAccount.error) {
                  return errorHandler('spaceNameSubmit')(
                    res.elevateAccount.error,
                    'Name your event Space'
                  )
                }

                if (res.elevateAccount.success) {
                  if (syncProfile) syncProfile()
                }
              },
            })
          }}
        >
          <Box className="mb-8">
            Looks like you don&apos;t have your own event Space yet. <br /> Not
            a problem, you can create one now.
          </Box>
          <TextInput
            label="Name your event Space"
            setError={errorHandler('spaceName')}
            required
          />
          <Button
            className="ml-auto overflow-hidden"
            buttonType="submit"
            title="Create Space"
            loading={loading}
          />
        </Form>
      </Box>
    </>
  )
}

export default SpaceCreationForm
